import { Middleware } from "redux";

import apiService from "api/apiService";
import {
  LOGOUT_REQUEST_BEGIN,
  LOGOUT_REQUEST_FAILURE,
  LOGOUT_REQUEST_SUCCESS,
} from "containers/authentication/redux/actionTypes";

const logoutMiddleware: Middleware = () => (next) => (action) => {
  if ((action as { type: string }).type === LOGOUT_REQUEST_BEGIN) {
    apiService.setLoggingOut(true);
  }

  const result = next(action);

  if (
    (action as { type: string }).type === LOGOUT_REQUEST_SUCCESS ||
    (action as { type: string }).type === LOGOUT_REQUEST_FAILURE
  ) {
    apiService.setClientId("");
    apiService.setToken("");
    apiService.setLoggingOut(false);
  }

  return result;
};

export default logoutMiddleware;
